import { render, staticRenderFns } from "./customer-survey-list.vue?vue&type=template&id=f4bdcd12"
import script from "./customer-survey-list.vue?vue&type=script&lang=js"
export * from "./customer-survey-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports